import gql from 'graphql-tag';

export const getMultiBuildingTaskFilterAttributesQuery = gql`
  query getMultiBuildingTaskFilterAttributesQuery($channelIds: [UUID!]) {
    multiBuildingTaskFilterAttributes(channelIds: $channelIds) {
      schedules {
        id
        name
      }
      statuses
      equipments {
        id
        name
      }
      assignees {
        id: _id
        name
      }
      locations
      transitionStatuses
    }
  }
`;
